import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataConstants } from '../../constants/reference-data-constants';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { UserPermissions } from '../../constants/user-permissions';
import { EditorConfiguration } from '../../models/editor-configuration.model';

@Component({
  selector: 'boi-case-message-editor',
  templateUrl: './case-message-editor.component.html',
  styleUrls: ['./case-message-editor.component.scss']
})
export class CaseMessageEditorComponent {
  @Input() public configuration: EditorConfiguration;

  @Output() public readonly sendMessageEmitter = new EventEmitter<string>();

  public sendMessageLabel = ReferenceDataLabels.CaseMessagingFormSendMessage;
  public referenceDataConstants = ReferenceDataConstants;
  public userPermissions = UserPermissions;

  public editorValue: string;
  public showErrorMessage = false;

  public sendMessage(): void {
    if (this.editorValue !== undefined && !this.renderedHtmlContainsOnlyWhitespace()) {
      this.editorValue = this.modifyContentRemoveStyleSpaces(this.editorValue);

      this.sendMessageEmitter.emit(this.editorValue);

      this.editorValue = '';
      this.showErrorMessage = false;
    } else {
      this.showErrorMessage = true;
    }
  }

  private renderedHtmlContainsOnlyWhitespace(): boolean {
    const divElement = document.createElement('div');
    divElement.innerHTML = this.editorValue;

    return divElement.innerText.trim() === '';
  }

  private modifyContentRemoveStyleSpaces(content: string): string {
    return content.replace(/style="(.*)"/g, (_match, styleBlock) => {
      const styleBlockNoSpaces = styleBlock.replace(/: /g, ':').replace(/; /g, ';').replace(/, /g, ',');

      return `style="${styleBlockNoSpaces}"`;
    });
  }
}
